import React from 'react';
import { Link } from 'react-router-dom';
import GoogleSignInButton from '../login/GoogleSignInButton';

interface TopBarProps {
  showGoogleSignIn?: boolean;
}

const TopBar: React.FC<TopBarProps> = ({showGoogleSignIn = true }) => {
  return (
    <div className="top-bar">
      <Link to="/" className="logo">
        Academic EMR For ALL
      </Link>
      {showGoogleSignIn && (
        <div className="sign-in-container">
          <GoogleSignInButton
            className={'home-sign-in-button'}
          />
        </div>
      )}
    </div>
  );
};

export default TopBar; 